import classNames from "classnames";

const ExecutionCell_NoData = () => {
  return <div className={classNames("text-gray-400")}>No Data</div>;
};
export default ExecutionCell_NoData;
